import { render, staticRenderFns } from "./EditServiceProvide.vue?vue&type=template&id=517e5c87"
import script from "./EditServiceProvide.vue?vue&type=script&lang=js"
export * from "./EditServiceProvide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports